export const ENVIRONMENT =
  import.meta.env.MODE ??
  process.env.NODE_ENV ??
  "development";

export const IS_DEV = ENVIRONMENT === "development";
